module.exports = __webpack_public_path__ + "static/fonts/element-icons.732389d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/openSurvey/theme/fonts/element-icons.ttf
// module id = V04u
// module chunks = 1